import { neutral05 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
export var MuiDrawer = {
    defaultProps: { elevation: 6 },
    styleOverrides: {
        root: {
            width: rem(240),
            flexShrink: 0,
            whiteSpace: 'nowrap',
            zIndex: 500,
        },
        paper: {
            width: rem(240),
            backgroundColor: neutral05,
        },
    },
};
